import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const DURATION = 17 * 60 + 34; // 00:17:34

function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(DURATION);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? DURATION : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const boxClass = tone === 'dark' ? 'bg-white/10 text-white ring-1 ring-white/20' : 'bg-navy text-white';
  const labelClass = tone === 'dark' ? 'text-white/60' : 'text-navy/50';
  const units = [{
    value: pad(hours),
    label: 'HOURS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  return <div className="flex flex-col items-center gap-2" data-id="element-18" data-mp="xytue8i8wn21">
      <p className={`flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.18em] ${tone === 'dark' ? 'text-gold' : 'text-navy/70'}`} data-id="element-19" data-mp="t12057u4oouo">
        <ClockIcon className="h-3.5 w-3.5" data-id="element-20" data-mp="12rmzwyljfzf6" />
        This offer expires in
      </p>
      <div className="flex items-start gap-2" role="timer" aria-live="off" data-id="element-21" data-mp="f1sn2h17yaux">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-22" data-mp="a40xvuryl2uf" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-23" data-mp="a5bzpp1ug0iw">
              <span className={`flex min-w-[3.25rem] justify-center rounded-xl px-2 py-2 font-display text-2xl font-bold tabular-nums sm:min-w-[3.75rem] sm:text-3xl ${boxClass}`} data-id="element-24" data-mp="o38vwkcdy4x1">
                {unit.value}
              </span>
              <span className={`mt-1 text-[10px] font-semibold tracking-[0.14em] ${labelClass}`} data-id="element-25" data-mp="1vgkhezhxds6v">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 ? <span className={`pt-1.5 font-display text-2xl font-bold sm:text-3xl ${tone === 'dark' ? 'text-white/40' : 'text-navy/30'}`} data-id="element-26" data-mp="x3ybaxrgpcn0">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
    </div>;
}